import './Base';

/** @namespace UI.Widget.Forms.Render */
NS("UI.Widget.Forms.Render");

/**
 * @class
 * @extends UI.Widget.Forms.Render.Base
 */
UI.Widget.Forms.Render.Light = Class(UI.Widget.Forms.Render.Base, /** @lends UI.Widget.Forms.Render.Light.prototype */ {
    template: "UI/Widget/Render/Light",
    baseClass: 'light-form',
    styles: ['form', 'light-form', 'overflow__no'],

    float: 'middle',

    adaptive: false,
    width: 460,

    paddingBase: 60,
    paddingIncrement: 20,

    titleField: 'item.name', // какое поле выводить в качестве тайтла
    subtitleField: null, // и подзаголовка

    /**
     * Настраивает форму и оборачивает ее в контейнер
     * Метод надо вызывать в методе render, если используется вместе с виджетом UI.Widget.Base
     *
     * @param {function} [ready]
     *
     * @returns {UI.Widget.Forms.Render.Light}
     */
    renderContainer: function(ready) {
        this.setAdaptive(this.adaptive);
        if (this.adaptive) {
            this.$element.addClass('adaptive-form');
            this.element.addEventListener("DOMNodeInserted", ::this.onElementAppend, false);

            var callback = ::this.updateWidth;
            $(window).on('resize', callback);
            this.on('destroy', function(){
                $(window).off("resize", callback);
            });
        } else {
            this.updateWidth();
        }

        this.setFloat(this.float);
        this.setWidth(this.width);

        if (!this.$element.hasClass('show')) {
            _.defer(function () {
                this.renderOverlay().renderButtons();
                this.$element.addClass("show");
                // 400 - время анимации в css с запасом, надо бы вынести это сюда в код
                _.delay(() => Util.call(ready), 400);
            }.bind(this));
        }

        return this;
    },
    /**
     * @param event
     */
    onElementAppend: function (event) {
        this.updateWidth();
    },
    /**
     * Пересчитывает и обновляет ширину и отступы контейнера формы
     * @returns {UI.Widget.Forms.Render.Light}
     */
    updateWidth: function () {
        if (this.$element && this.$element.length) {
            if (this.adaptive) {
                if (this.$element.parent()) {
                    var margin = 20;
                    if (this.float == 'left') {
                        margin = parseInt(this.$element.css('left')) ? parseInt(this.$element.css('left')) : margin;
                    } else if (this.float == 'right') {
                        margin = parseInt(this.$element.css('right')) ? parseInt(this.$element.css('right')) : margin;
                    }
                    if (typeof this.width == "string" && this.width.indexOf('%') != -1) {
                        this.$element.css('width', this.width);
                        this.$element.removeClass('double-column');
                    } else {
                        if (this.width * 2 < $('body').width() - margin * 2) {
                            this.$element.css('width', this.width * 2);
                            this.$element.addClass('double-column');
                        } else {
                            this.$element.css('width', this.width);
                            this.$element.removeClass('double-column');
                        }
                    }
                }
            } else {
                if (this.width) this.$element.css('width', this.width);
            }
        }

        return this;
    },
    close() {
        if (this.isDestroyed) {
            return;
        }
        var parentMethod = this.ParentMethod();
        this.emit("close.before");
        this.$element/*.attr('style', '')*/.removeClass("show");
        _.delay(() => this.CallMethod(parentMethod), 310);
    },
    /**
     * @param {Element} el
     * @param {Event} evt
     */
    onCloseClick: function(el, evt) {
        if (evt) {
            evt.stopPropagation();
        }

        this.close();
    },

    /**
     * @param {Element} el
     * @param {Event} e
     */
    onCancelClick: function(el, e) {
        this.onCloseClick(el, e);
    },

    /**
     * @param {Element} el
     * @param {Event} e
     */
    onSaveClickSuccess: function(el, e) {
        this.onCloseClick(el, e);
    },

    setFloat: function(float) {
        this.float = float;

        if (this.$element && this.$element.length) {
            this.$element.addClass(this.float);
            if (this.float == 'left') {
                this.$element.css('left', this.paddingBase + $('.left.' + this.baseClass).length * this.paddingIncrement);
            } else if (this.float == 'right') {
                this.$element.css('right', this.paddingBase + $('.right.' + this.baseClass).length * this.paddingIncrement);
            }
        }

        return this;
    },
    /**
     * @param {number|string} width
     * @returns {UI.Widget.Forms.Render.Light}
     */
    setWidth: function(width) {
        this.width = width;
        this.updateWidth();

        return this;
    },
    /**
     *
     * @param {boolean} adaptive
     * @returns {UI.Widget.Forms.Render.Light}
     */
    setAdaptive: function(adaptive) {
        if (adaptive == null) {
            adaptive = true;
        }

        this.adaptive = adaptive;
        this.updateWidth();

        return this;
    }
});
